import React from 'react'
import classnames from 'classnames'
import { compose, withProps } from 'recompose'

import Button from 'src/Components/shared/Button'
import { Unless } from 'src/Components'
import { IconCommentingFa } from 'src/Components/shared/Icon'
import styles from './DirectMessageButton.module.scss'

const DirectMessageButton = compose(
  withProps(({ className, loading }) => ({
    'data-qa': 'directMessageButton',
    children: (
      <Unless condition={loading}>
        <IconCommentingFa className={styles.icon} />
      </Unless>
    ),
    className: classnames(styles.button, loading && styles.loading, className),
    compact: true
  }))
)(props => <Button {...props} />)

export default DirectMessageButton
